import { Navigate } from 'react-router-dom';

import PrivateRoutes from 'routes/PrivateRoutes';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import OnboardingWrapper from 'components/practice/Onboarding/OnboardingWrapper';

import {
  PRACTICE_BEYOND_BILLING,
  PRACTICE_CHARTS,
  PRACTICE_COMMS_CENTER,
  PRACTICE_SETTINGS
} from './index';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const OnboardingWizard = withLazyFallback(
  () => import('components/shared/OnboardingWizard/OnboardingWizard')
);
const AuditLogs = withLazyFallback(() => import('components/audit/logs/AuditLogs'));
const PracticePortal = withLazyFallback(() => import('components/practice'));
const Calendar = withLazyFallback(() => import('components/practice/Calendar/Calendar'));
const Dashboard = withLazyFallback(() => import('components/practice/Dashboard/Dashboard'));
const PracticeDocuments = withLazyFallback(
  () => import('components/practice/Documents/PracticeDocuments')
);
const PracticeIQueue = withLazyFallback(() => import('components/practice/PracticeIQueue'));
const AppointmentsQueue = withLazyFallback(
  () => import('components/practice/PracticeIQueue/Appointments/AppointmentsQueue')
);
const ClinicalNotes = withLazyFallback(
  () => import('components/practice/PracticeIQueue/ClinicalNotes/ClinicalNotes')
);
const FormPacket = withLazyFallback(
  () => import('components/practice/PracticeIQueue/FormPacket/FormPacket')
);
const Notifications = withLazyFallback(
  () => import('components/practice/PracticeIQueue/Notifications/Notifications')
);
const Orders = withLazyFallback(() => import('components/practice/PracticeIQueue/Orders/Orders'));
const Overview = withLazyFallback(
  () => import('components/practice/PracticeIQueue/Overview/Overview')
);
const Tasks = withLazyFallback(() => import('components/practice/PracticeIQueue/Tasks/Tasks'));
const ViewTask = withLazyFallback(
  () => import('components/practice/PracticeIQueue/Tasks/components/ViewTask')
);
const TreatmentPlanIQueue = withLazyFallback(
  () => import('components/practice/PracticeIQueue/TreatmentPlan')
);

const PRACTICE_DASHBOARD = [
  {
    path: '',
    element: <PrivateRoutes type="portal" />,
    children: [
      {
        path: 'portal',
        element: <PracticePortal />,
        children: [
          { path: 'dashboard', element: <Dashboard />, handle: { title: 'Dashboard' } },
          { path: '', element: <Navigate to="dashboard" replace /> },

          ...PRACTICE_CHARTS,
          ...PRACTICE_BEYOND_BILLING,
          ...PRACTICE_COMMS_CENTER,
          ...PRACTICE_SETTINGS,

          {
            path: 'onboarding',
            element: <OnboardingWrapper />,
            children: [
              {
                path: '',
                element: <OnboardingWizard />
              },
              {
                path: 'review',
                element: <OnboardingWizard />
              },
              {
                path: ':step_id',
                element: <OnboardingWizard />
              },
              {
                path: ':step_id/:substep_id',
                element: <OnboardingWizard />
              }
            ]
          },
          {
            path: 'audit',
            children: [{ path: 'logs', element: <AuditLogs />, handle: { title: 'Audit Logs' } }]
          },
          {
            path: 'appointments',
            element: <Calendar />,
            handle: { title: 'Calendar' },
            children: [{ path: '*', element: <NotFound /> }]
          },

          { path: 'documents', element: <PracticeDocuments />, handle: { title: 'Documents' } },

          {
            path: 'documents/:pathId',
            element: <PracticeDocuments />,
            handle: { title: 'Documents' }
          },
          {
            path: 'practice-i-queue',
            element: <PracticeIQueue />,
            handle: { title: 'Practice I-Queue' },
            children: [
              { path: '', element: <Overview />, handle: { title: 'Overview' } },
              {
                path: 'tasks',
                element: <Tasks />,
                handle: { title: 'Tasks' },
                children: [
                  { path: ':id', element: <ViewTask /> },
                  { path: '*', element: <NotFound /> }
                ]
              },
              {
                path: 'clinical-notes',
                element: <ClinicalNotes />,
                handle: { title: 'Clinical Notes' }
              },
              {
                path: 'treatment-plans',
                element: <TreatmentPlanIQueue />,
                handle: { title: 'Treatment Plans' }
              },
              {
                path: 'notifications',
                element: <Notifications />,
                handle: { title: 'Notifications' }
              },
              {
                path: 'appointments',
                element: <AppointmentsQueue />,
                handle: { title: 'Appointments' }
              },
              { path: 'forms', element: <FormPacket />, handle: { title: 'Forms' } },
              {
                path: 'orders',
                element: <Orders fromPatient={false} />,
                handle: { title: 'Orders' }
              }
            ]
          },

          { path: '*', element: <NotFound portal="portal" /> }
        ]
      }
    ]
  }
];

export default PRACTICE_DASHBOARD;
